import { render } from "./burchoure.vue?vue&type=template&id=86ab442a&scoped=true"
import script from "./burchoure.vue?vue&type=script&lang=js"
export * from "./burchoure.vue?vue&type=script&lang=js"

import "./burchoure.vue?vue&type=style&index=0&id=86ab442a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-86ab442a"

export default script